import React, {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useCallback,
  useContext,
  useRef,
  useState
} from 'react';
import { TextInput } from 'react-native';

export interface FormContextProps {
  focusedInput?: TextInput;
  setFocusedInput: Dispatch<SetStateAction<TextInput | undefined>>;
  addInput: (textInput: TextInput) => void;
  focusNext: () => void;
}

export const FormContext = createContext<FormContextProps>(null!);

export const useFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error(
      'useFormContext must be used within the context of the Form component'
    );
  }
  return context;
};

const Form: React.FC<PropsWithChildren> = ({ children }) => {
  const textInputsRef = useRef<TextInput[]>([]);
  // const [textInputs, setTextInputs] = useState<TextInput[]>([]);
  const [focusedInput, setFocusedInput] = useState<TextInput>();
  const addInput = useCallback((textInput: TextInput) => {
    textInputsRef.current.push(textInput);
    // setTextInputs(textInputs => [...textInputs, textInput]);
  }, []);
  const focusNext = useCallback(() => {
    if (focusedInput) {
      const index = textInputsRef.current.findIndex(
        input => input === focusedInput
      );
      if (index > -1) {
        textInputsRef.current[index + 1]?.focus();
      }
    }
  }, [focusedInput]);
  return (
    <FormContext.Provider
      value={{
        focusedInput,
        setFocusedInput,
        addInput,
        focusNext
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export default Form;
